import produce from "immer";
import find from "lodash/find";
import uniqBy from "lodash/uniqBy";
import { CustomizationState } from "../";
import { SelectionPhoto } from "../../../types/selection/selection";

export interface AddOrUpdateSelectionPhotoAction {
  type: "addOrUpdateSelectionPhoto";
  selectionPhoto: SelectionPhoto;
}

export function addOrUpdateSelectionPhoto(
  state: CustomizationState,
  action: AddOrUpdateSelectionPhotoAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { selectionPhoto } = action;
    const selectionPhotos = draftState.selection.photos;

    const existingPhotoByKey = find(selectionPhotos, ({ key }) => key === selectionPhoto.key);
    const existingPhotoByLocalRef = find(
      selectionPhotos,
      ({ localRef }) => !!localRef && localRef === selectionPhoto.localRef
    );

    if (existingPhotoByKey) {
      if (!existingPhotoByKey.fotomKey) {
        Object.assign(existingPhotoByKey, selectionPhoto);
      }
    } else if (existingPhotoByLocalRef) {
      if (!existingPhotoByLocalRef.fotomKey) {
        Object.assign(existingPhotoByLocalRef, selectionPhoto);
      }
    } else {
      selectionPhotos.push(selectionPhoto);
    }

    // todo :
    // * if successfull replace local id with definitive here and in content ?

    draftState.selection.photos = uniqBy(draftState.selection.photos, "key");
    draftState.selection.photos = uniqBy(draftState.selection.photos, "fotomKey");
  });
}
